import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import HotelTooltipsTooltipRateRoomtype from 'lumen/components/hotel/tooltips/tooltip-rate-roomtype';

interface ParityTooltipsTooltipParityOverviewTableSignature {
  Args: {
    formattedRate: string | null;
    issue: unknown;
    message: string | undefined;
  };
}

export default class ParityTooltipsTooltipParityOverviewTable extends Component<ParityTooltipsTooltipParityOverviewTableSignature> {
  get hasRate(): boolean {
    // @ts-expect-error: Property 'value' does not exist on type '{}'.
    return this.args.issue?.value !== 0;
  }

  <template>
    {{#unless (eq @message "general.missing")}}
      <HotelTooltipsTooltipRateRoomtype
        {{! @glint-expect-error: Property 'extractDatetime' does not exist on type '{}'. }}
        @extractDatetime={{@issue.extractDatetime}}
        @fetchOtherLosRates={{false}}
        @forceShowUpdateTime={{true}}
        {{! @glint-expect-error: Type 'string | null' is not assignable to type 'string | undefined'. }}
        @formattedRateOverride={{@formattedRate}}
        @hasRate={{this.hasRate}}
        {{! @glint-expect-error: Property 'roomName' does not exist on type '{}'. }}
        @roomNameOverride={{@issue.roomName}}
        {{! @glint-expect-error: Argument of type 'unknown' is not assignable to parameter of type 'Element'. }}
        class="rates-table-tooltip"
      />
    {{/unless}}
  </template>
}
